module.exports = __webpack_public_path__ + "static/CurrentHomeowner-1381e502cf130f02d9eb9dd88a27fc99.png";